import highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import styled from 'styled-components'

interface ColumnChartProps {
  title?: string
  subTitle?: string
  xAxisLabel?: string
  yAxisLabel?: string
  categories?: string[]
  data?: number[]
  displayLegend?: boolean
}

export const ColumnChart = ({
  title,
  subTitle,
  xAxisLabel,
  yAxisLabel,
  categories,
  data,
  displayLegend = false
}: ColumnChartProps) => {
  const config = {
    chart: {
      height: 230,
      type: 'column'
    },
    title: {
      text: title,
      align: 'left'
    },
    subtitle: {
      text: subTitle,
      align: 'left'
    },
    yAxis: {
      title: {
        text: yAxisLabel
      }
    },
    xAxis: {
      categories,
      title: {
        text: xAxisLabel
      }
    },
    tooltip: {
      valueDecimals: 0
    },
    plotOptions: {
      series: {
        stacking: 'normal'
      }
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: displayLegend,
      layout: 'horizontal',
      align: 'right',
      verticalAlign: 'middle'
    },
    series: [
      {
        name: 'Actions',
        data
      }
    ]
  }
  return (
    <Container>
      <HighchartsReact highcharts={highcharts} options={config} />
    </Container>
  )
}

export default ColumnChart

const Container = styled.div`
  border-radius: 25px;
  background-size: 90%;
  background-position-x: 35%;
  background-position-y: center;
  background-repeat: no-repeat;
  color: ${({ theme }) => theme.color.neutral.color11};

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    background-size: 250%;
    background-position-x: 5%;
    background-position-y: bottom;
  }
`
